import PublicProposalView from "@/components/proposals/PublicProposalView";

const PublicProposal = () => {
  return <PublicProposalView />;
};

export default PublicProposal;
